var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.375V0H4.375V1.5H1.5V4.375H0ZM18.5 4.375V1.5H15.625V0H20V4.375H18.5ZM0 22V17.625H1.5V20.5H4.375V22H0ZM15.625 22V20.5H18.5V17.625H20V22H15.625ZM4.5 17.5H15.5V4.5H4.5V17.5ZM4.5 19C4.1 19 3.75 18.85 3.45 18.55C3.15 18.25 3 17.9 3 17.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H15.5C15.9 3 16.25 3.15 16.55 3.45C16.85 3.75 17 4.1 17 4.5V17.5C17 17.9 16.85 18.25 16.55 18.55C16.25 18.85 15.9 19 15.5 19H4.5ZM7.25 8.75H12.75V7.25H7.25V8.75ZM7.25 11.75H12.75V10.25H7.25V11.75ZM7.25 14.75H12.75V13.25H7.25V14.75ZM4.5 17.5V4.5V17.5Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.ada58accfe697ccfcb28ff6e11b77cd5.svg";
export { ForwardRef as ReactComponent };